import React, { useState } from "react";
import axios from "axios";
import { Lock, ShieldCheck } from "lucide-react";
import { useT } from "../i18n";
import { AUTH } from "../constants/testIds";

export default function AdminGate({ API, lang, onLogin }) {
    const T = useT(lang);
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            const r = await axios.post(`${API}/admin/login`, { password });
            onLogin(r.data.token);
        } catch (err) {
            setError(T.wrongPassword);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-[60vh] flex items-center justify-center py-12 fade-up">
            <div className="w-full max-w-md bg-white border border-[#E2E8F0] rounded-2xl shadow-[0_14px_60px_rgba(15,23,42,0.08)] p-8">
                <div className="flex flex-col items-center text-center mb-6">
                    <div className="w-16 h-16 rounded-2xl bg-[#1A365D] flex items-center justify-center mb-4 shadow-lg">
                        <Lock size={28} color="#D4AF37" />
                    </div>
                    <h2 className="font-serif text-2xl font-bold text-[#1A365D]">{T.adminLogin}</h2>
                    <p className="text-sm text-[#475569] mt-1">{T.adminLoginHint}</p>
                </div>

                <form onSubmit={submit} className="space-y-4">
                    <div>
                        <label className="text-xs uppercase tracking-wider font-semibold text-[#1A365D] block mb-1.5">
                            {T.password}
                        </label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="input-royal"
                            placeholder="••••••••••"
                            data-testid={AUTH.passwordInput}
                            required
                        />
                    </div>
                    {error && (
                        <p className="text-sm text-red-600 font-medium" data-testid={AUTH.errorMsg}>
                            {error}
                        </p>
                    )}
                    <button
                        type="submit"
                        disabled={loading}
                        className="btn-royal w-full justify-center"
                        data-testid={AUTH.submitBtn}
                    >
                        <ShieldCheck size={18} />
                        {loading ? "..." : T.enter}
                    </button>
                </form>
            </div>
        </div>
    );
}
